import { useEffect, useState } from "react";
import "./App.css";
import { PortalChoferAppScreen, PortalChoferLinkedCompaniesScreen, PortalChoferRequestsScreen, PortalChoferScreen } from "./screens/choferPortals";
import {
  PortalEmpresaTransporteChoferesScreen,
  PortalEmpresaTransporteDebugScreen,
  PortalEmpresaTransporteAppScreen,
  PortalEmpresaTransporteAuthScreen,
  PortalEmpresaTransporteCompaniesScreen,
  PortalEmpresaTransporteFleetScreen,
  PortalEmpresaTransporteRequestsScreen,
  PortalEmpresaTransporteSignedContractsScreen,
} from "./screens/companyPortals";
import { AdminDashboardScreen } from "./screens/adminScreen";
import { CameraDemoScreen, EventDetailScreen, HealthScreen, PortalHomeScreen } from "./screens/miscScreens";

function App() {
  const [route, setRoute] = useState(() => getRouteFromHash(window.location.hash));

  useEffect(() => {
    const handleHashChange = () => setRoute(getRouteFromHash(window.location.hash));
    window.addEventListener("hashchange", handleHashChange);
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  if (route.name === "evento-detalle") {
    return <EventDetailScreen eventId={route.eventId} backHash={route.backHash} portalTitle={route.portalTitle} />;
  }

  if (route.name === "portal-chofer") {
    return <PortalChoferScreen />;
  }

  if (route.name === "portal-chofer-app") {
    return <PortalChoferAppScreen cuitFromRoute={route.cuit || ""} />;
  }

  if (route.name === "portal-chofer-requests") {
    return <PortalChoferRequestsScreen cuitFromRoute={route.cuit || ""} />;
  }

  if (route.name === "portal-chofer-linked-companies") {
    return <PortalChoferLinkedCompaniesScreen cuitFromRoute={route.cuit || ""} />;
  }

  if (route.name === "portal-empresa-transporte-auth") {
    return <PortalEmpresaTransporteAuthScreen />;
  }

  if (route.name === "portal-empresa-transporte-app") {
    return <PortalEmpresaTransporteAppScreen />;
  }

  if (route.name === "portal-empresa-transporte-choferes") {
    return <PortalEmpresaTransporteChoferesScreen />;
  }

  if (route.name === "portal-empresa-transporte-fleet") {
    return <PortalEmpresaTransporteFleetScreen />;
  }

  if (route.name === "portal-empresa-transporte-companies") {
    return <PortalEmpresaTransporteCompaniesScreen />;
  }

  if (route.name === "portal-empresa-transporte-requests") {
    return <PortalEmpresaTransporteRequestsScreen />;
  }

  if (route.name === "portal-empresa-transporte-signed-contracts") {
    return <PortalEmpresaTransporteSignedContractsScreen />;
  }

  if (route.name === "portal-empresa-transporte-debug") {
    return <PortalEmpresaTransporteDebugScreen />;
  }

  if (route.name === "camera-demo") {
    return <CameraDemoScreen />;
  }

  if (route.name === "health") {
    return <HealthScreen />;
  }

  if (route.name === "admin") {
    return <AdminDashboardScreen />;
  }

  return <PortalHomeScreen />;
}

function getRouteFromHash(hash) {
  const hashPath = String(hash || "").split("?")[0];
  const transporteMatch =
    hashPath.match(/^#\/portal-empresa-transporte\/app\/eventos\/([^/]+)$/) ||
    hashPath.match(/^#\/portal-transporte\/eventos\/([^/]+)$/);
  if (transporteMatch) {
    return {
      name: "evento-detalle",
      eventId: transporteMatch[1],
      backHash: "#/portal-empresa-transporte/app",
      portalTitle: "Portal Empresa de Transporte",
    };
  }

  if (hashPath === "#/portal-chofer") {
    return { name: "portal-chofer" };
  }

  const choferRequestsMatch = hashPath.match(/^#\/portal-chofer\/app\/([^/]+)\/solicitudes$/);
  if (choferRequestsMatch) {
    return { name: "portal-chofer-requests", cuit: choferRequestsMatch[1] };
  }

  const choferLinkedCompaniesMatch = hashPath.match(/^#\/portal-chofer\/app\/([^/]+)\/empresas-vinculadas$/);
  if (choferLinkedCompaniesMatch) {
    return { name: "portal-chofer-linked-companies", cuit: choferLinkedCompaniesMatch[1] };
  }

  const choferAppMatch = hashPath.match(/^#\/portal-chofer\/app\/([^/]+)$/);
  if (choferAppMatch) {
    return { name: "portal-chofer-app", cuit: choferAppMatch[1] };
  }

  if (hashPath === "#/portal-chofer/app") {
    return { name: "portal-chofer-app" };
  }

  if (hashPath === "#/portal-empresa-transporte/auth" || hashPath === "#/portal-transporte") {
    return { name: "portal-empresa-transporte-auth" };
  }

  if (hashPath === "#/portal-empresa-transporte/app") {
    return { name: "portal-empresa-transporte-app" };
  }

  if (hashPath === "#/portal-empresa-transporte/app/choferes") {
    return { name: "portal-empresa-transporte-choferes" };
  }

  if (hashPath === "#/portal-empresa-transporte/app/flota") {
    return { name: "portal-empresa-transporte-fleet" };
  }

  if (hashPath === "#/portal-empresa-transporte/app/empresas") {
    return { name: "portal-empresa-transporte-companies" };
  }

  if (hashPath === "#/portal-empresa-transporte/app/solicitudes") {
    return { name: "portal-empresa-transporte-requests" };
  }

  if (hashPath === "#/portal-empresa-transporte/app/contratos-firmados") {
    return { name: "portal-empresa-transporte-signed-contracts" };
  }

  if (hashPath === "#/portal-empresa-transporte/debug") {
    return { name: "portal-empresa-transporte-debug" };
  }

  if (hashPath === "#/demo/camera") {
    return { name: "camera-demo" };
  }

  if (hashPath === "#/health") {
    return { name: "health" };
  }

  if (hashPath === "#/admin") {
    return { name: "admin" };
  }

  return { name: "home" };
}

export default App;
